export class DeleteOperationAction {
    _operation: any;
    _layer: any;

    constructor(operation, layer) {
        var self = this;
        self._operation = operation;
        self._layer = layer;
    }

    exec() {
        var self = this;
        self._layer.deleteOperation(self._operation);
    }

    unexec() {
        var self = this;
        self._layer.addOperation(self._operation);
    }

    destroy() {
        var self = this;
        self._operation.destroy();
    }

}